import {
  CONTENT_POSITION_X_CSS_PROPERTY,
  CONTENT_POSITION_Y_CSS_PROPERTY,
  CONTENT_SCALE_CSS_PROPERTY,
} from 'src/js/modules/extensions/registry/ws-image/constants/media-container';

const PROPERTIES_TO_CLEAR = [
  CONTENT_POSITION_X_CSS_PROPERTY,
  CONTENT_POSITION_Y_CSS_PROPERTY,
  CONTENT_SCALE_CSS_PROPERTY,
];

const clearProperties = (image) => {
  if (!image?.style) return;

  PROPERTIES_TO_CLEAR.forEach((property) => {
    image.style.removeProperty(property);
  });
};

const clearRepositionedImageInlineStyles = (image, { immediate = false } = {}) => {
  if (immediate) {
    clearProperties(image);
    return;
  }

  requestAnimationFrame(() => {
    clearProperties(image);
  });
};

export default clearRepositionedImageInlineStyles;
